import { Ticker } from 'pixi.js';
import state from '../state';

class DifficultyManager {
  constructor() {
    this.accumulator = 0;
    this.threshold = 50; // Every 100mt update level

    this.frameHandler = () => { this.frame(); };

    Ticker.shared.add(this.frameHandler);
  }

  frame() {
    const mt = 0.02 * state.speed;
    state.meters += mt;
    this.accumulator += mt;
    if (this.accumulator > this.threshold) {
      state.level += 1;
      this.accumulator = 0;
    }
  }

  destroy() {
    Ticker.shared.remove(this.frameHandler);
  }
}

export default DifficultyManager;
